import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found | Kinews Studio" noindex />
      <main className="flex min-h-[70vh] flex-col items-center justify-center px-6 pb-16 pt-28 text-center">
        <p className="text-sm font-medium uppercase tracking-[0.35em] text-pink-400">
          Error 404
        </p>
        <h1 className="mt-4 text-3xl font-semibold tracking-tight md:text-5xl">
          We can&apos;t find that page
        </h1>
        <p className="mt-4 max-w-md text-white/70">
          The page you are looking for may have moved or no longer exists.
          Here are some places to get back on track.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="inline-flex rounded-full bg-pink-500 px-7 py-3 text-sm font-medium text-white transition hover:bg-pink-600 items-center gap-2"
          >
Back to Home
<ArrowRight size={18} aria-hidden="true" />
</Link>
          <Link
            to="/book"
            className="inline-flex rounded-full border border-pink-500/40 px-7 py-3 text-sm text-white transition hover:bg-pink-500/10 items-center gap-2"
          >
Book a Session
<ArrowRight size={18} aria-hidden="true" />
</Link>
          <Link
            to="/gallery"
            className="inline-flex rounded-full border border-pink-500/40 px-7 py-3 text-sm text-white transition hover:bg-pink-500/10 items-center gap-2"
          >
See Our Work
<ArrowRight size={18} aria-hidden="true" />
</Link>
        </div>
      </main>
    </>
  );
}
